import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'
import { useTranslation } from 'react-i18next'

import type { SegmentedControlOption } from '@enechain/ecloud-designsystem'

import { AccessibleSegmentedControl } from '~/components/common/AccessibleSegmentedControl'
import { AREA_CODE_OPTIONS, convertAreaLabel } from '~/models/area'

const ALL = 'all'

type Props = {
  value: AreaCode | undefined
  /** undefined = すべて。 */
  onChange: (value: AreaCode | undefined) => void
  name: string
}

/** エリアの絞り込み (すべて + 10 エリアのボタン群。 モックの `AreaFilterButtons`)。 */
export const AreaButtons = ({
  value,
  onChange,
  name,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const options: Array<SegmentedControlOption<string>> = [
    { value: ALL, label: t('page:customerInfo.common.all') },
    ...AREA_CODE_OPTIONS.map((code) => ({
      value: String(code),
      label: convertAreaLabel(code),
    })),
  ]
  return (
    <AccessibleSegmentedControl
      aria-label={t('page:customerInfo.common.area')}
      name={name}
      onSelect={(next) =>
        onChange(next === ALL ? undefined : (Number(next) as AreaCode))
      }
      options={options}
      selected={value === undefined ? ALL : String(value)}
    />
  )
}
